import React, { Component } from 'react';
import { TYPES } from '../../../constants/enums';
import * as COLORS from '../../../constants/colors';

class Input extends Component {

	constructor(props) {
		super(props);
		this.state = {
			valid: true,
			errorMessage: '',
			objectType: this.props.objectType,
		};

		this.inputChanged = this.inputChanged.bind(this);
	}

	inputChanged(e) {
		const newValue = e.target.value;
		let valid = true;
		let errorMessage = '';

		switch(this.props.objectType){
			case TYPES.NUMBER:{
				valid = !isNaN(Number(newValue));
				errorMessage = `${newValue} must be a number`;
				break;
			}
			case TYPES.BOOLEAN: {
				valid = newValue === 'true' || newValue === 'false' || typeof(newValue) === 'boolean'
				errorMessage = `${newValue} must be a boolean`;
				break;
			}
			default:{}
		}

		this.setState({
			valid: valid,
			errorMessage: errorMessage,
		});

		if (typeof this.props.onChange === 'function') {
			this.props.onChange(newValue);
		}

	}

	render() {
		const { label, type, value, name, disabled, id } = this.props;
		const styles = {
    inputComponent:{
    	input: {
        padding: '5px',
        fontSize: '12px',
        lineHeight: '18px',
        display: 'block',
        width: '100%',
        marginBottom: '18px',
			  borderRadius: '3px',
				border: '1px solid #c8c7cc',
      },
			errorMessage: {
				color: COLORS.ERROR_COLOR,
				marginTop: '-17px',
			}
    }
	 };

		return (
		<div className="input-component">
				{label !=null ?
					<label>
						{label}
						<br />
					</label>:null
				}
				<input
					type={type}
					value={value}
					name={name}
					id={id}
					disabled={disabled}
					onChange={this.inputChanged}
					style={styles.inputComponent.input}
				/>
			{ this.state.valid ? null :
			<label style={styles.inputComponent.errorMessage}>
				{this.state.errorMessage}
				<br />
			</label> }
		</div>
		);
	}

}

export default Input;
